<template>
    <b-modal
        modal-class="modal-full action-modal"
        :visible="visible"
        scrollable
    >
        <template #modal-header>
            <div class="container">
                <h3 class="mb-0">End User Licence Agreement</h3>
            </div>
            <button @click="logout" type="button" aria-label="Close" class="close">×</button>
        </template>
        <div class="container">
            <riskhub-vue-element-loading :active="loading" :is-full-screen="true" />
            <terms-and-conditions>
            </terms-and-conditions>
        </div>
        <template #modal-footer>
            <div class="container text-center">
                <div>
                    <b-form-checkbox
                            id="accepted"
                            v-model="terms.accepted"
                            name="accepted"
                            class="mb-3"
                    >
                        I accept the EULA
                    </b-form-checkbox>
                </div>
                <b-btn
                    variant="yellow"
                    @click="acceptTerms"
                    :disabled="!terms.accepted"
                >
                    Proceed
                </b-btn>
            </div>
        </template>
    </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import User from '@/services/User/User';
import TermsAndConditions from '@/components/User/TermsAndConditions';

export default {
  name: 'Terms-Conditions-Modal',
  components: {
    TermsAndConditions,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'termsConditionsModal',
      loading: false,
      visible: false,
      terms: {
        accepted: false,
      },
    };
  },
  watch: {
    show: {
      handler(newValue) {
        this.visible = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$emit('update:show', false);
    },
    async acceptTerms() {
      this.loading = true;

      try {
        await User.acceptTerms();
        await this.$store.dispatch('fetchUser');
        // We don't need to hide the modal because it's being controlled externally
      } catch (e) {

      } finally {
        this.loading = false;
      }
    },
    async logout() {
      await this.$store.dispatch('logout');
    },
  },
};
</script>

<style lang="scss" scoped>
    /deep/ .modal-body {
        margin-bottom: 127px !important;
    }
</style>
